<template>
  <div class="h-full">
    <div
      v-if="
        Object.keys(organizationConfiguration) &&
        Object.keys(organizationConfiguration).length
      "
    >
      <div>
        <div class="float-left clear-both mb-base">
          <h5>
            {{ organizationConfiguration["department"].title }}
          </h5>
          <div
            v-if="organizationConfiguration['department'].type === 'dropdown'"
          >
            <span
              v-for="(configValue, i2) of organizationConfiguration[
                'department'
              ].values"
              :key="i2"
              class="text-primary px-3 py-2 mb-3 mr-3"
              :style="{
                background: 'rgba(var(--vs-primary), 0.1)',
                'border-radius': '1000px',
                'line-height': '3',
              }"
            >
              {{ configValue.label }}
            </span>
          </div>
          <div v-else-if="organizationConfiguration['department'].type">
            Type: {{ organizationConfiguration["department"].type }}
          </div>
        </div>

        <div class="float-left clear-both mb-base">
          <h5>
            {{ organizationConfiguration["roleTitle"].title }}
          </h5>
          <div
            v-if="organizationConfiguration['roleTitle'].type === 'dropdown'"
          >
            <span
              v-for="(configValue, i2) of organizationConfiguration['roleTitle']
                .values"
              :key="i2"
              class="text-primary px-3 py-2 mb-3 mr-3"
              :style="{
                background: 'rgba(var(--vs-primary), 0.1)',
                'border-radius': '1000px',
                'line-height': '3',
              }"
            >
              {{ configValue.label }}
            </span>
          </div>
          <div v-else-if="organizationConfiguration['roleTitle'].type">
            Type: {{ organizationConfiguration["roleTitle"].type }}
          </div>
        </div>

        <div class="float-left clear-both mb-base">
          <h5>
            {{ organizationConfiguration["level"].title }}
          </h5>
          <div v-if="organizationConfiguration['level'].type === 'dropdown'">
            <span
              v-for="(configValue, i2) of organizationConfiguration['level']
                .values"
              :key="i2"
              class="text-primary px-3 py-2 mb-3 mr-3"
              :style="{
                background: 'rgba(var(--vs-primary), 0.1)',
                'border-radius': '1000px',
                'line-height': '3',
              }"
            >
              {{ configValue.label }}
            </span>
          </div>
          <div v-else-if="organizationConfiguration['level'].type">
            Type: {{ organizationConfiguration["level"].type }}
          </div>
        </div>

        <div class="float-left clear-both mb-base">
          <h5>
            {{ organizationConfiguration["numberOfDirectReports"].title }}
          </h5>
          <div
            v-if="
              organizationConfiguration['numberOfDirectReports'].type ===
              'dropdown'
            "
          >
            <span
              v-for="(configValue, i2) of organizationConfiguration[
                'numberOfDirectReports'
              ].values"
              :key="i2"
              class="text-primary px-3 py-2 mb-3 mr-3"
              :style="{
                background: 'rgba(var(--vs-primary), 0.1)',
                'border-radius': '1000px',
                'line-height': '3',
              }"
            >
              {{ configValue.label }}
            </span>
          </div>
          <div
            v-else-if="organizationConfiguration['numberOfDirectReports'].type"
          >
            Type: {{ organizationConfiguration["numberOfDirectReports"].type }}
          </div>
        </div>

        <div class="float-left clear-both mb-base">
          <h5>
            {{ organizationConfiguration["performance"].title }}
          </h5>
          <div
            v-if="organizationConfiguration['performance'].type === 'dropdown'"
          >
            <span
              v-for="(configValue, i2) of organizationConfiguration[
                'performance'
              ].values"
              :key="i2"
              class="text-primary px-3 py-2 mb-3 mr-3"
              :style="{
                background: 'rgba(var(--vs-primary), 0.1)',
                'border-radius': '1000px',
                'line-height': '3',
              }"
            >
              {{ configValue.label }}
            </span>
          </div>
          <div v-else-if="organizationConfiguration['performance'].type">
            Type: {{ organizationConfiguration["performance"].type }}
          </div>
        </div>

        <div class="float-left clear-both mb-base">
          <h5>
            {{ organizationConfiguration["potential"].title }}
          </h5>
          <div
            v-if="organizationConfiguration['potential'].type === 'dropdown'"
          >
            <span
              v-for="(configValue, i2) of organizationConfiguration['potential']
                .values"
              :key="i2"
              class="text-primary px-3 py-2 mb-3 mr-3"
              :style="{
                background: 'rgba(var(--vs-primary), 0.1)',
                'border-radius': '1000px',
                'line-height': '3',
              }"
            >
              {{ configValue.label }}
            </span>
          </div>
          <div v-else-if="organizationConfiguration['potential'].type">
            Type: {{ organizationConfiguration["potential"].type }}
          </div>
        </div>

        <!-- Relationship   -->
        <div class="float-left clear-both mb-base">
          <h5>
            {{ organizationConfiguration["relationship"].title }}
          </h5>
          <div
            v-if="organizationConfiguration['relationship'].type === 'dropdown'"
          >
            <span
              v-for="(configValue, i) of organizationConfiguration[
                'relationship'
              ].values"
              :key="i"
              class="text-primary px-3 py-2 mb-3 mr-3"
              :style="{
                background: 'rgba(var(--vs-primary), 0.1)',
                'border-radius': '1000px',
                'line-height': '3',
              }"
            >
              {{ configValue.label }}
            </span>
          </div>
          <div v-else-if="organizationConfiguration['relationship'].type">
            Type: {{ organizationConfiguration["relationship"].type }}
          </div>
        </div>
      </div>
    </div>
    <div v-else class="items-center md:mt-12 lg:mt-10F">
      No Organization Configuration Found
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
    orgData() {
      return this.$store.state.organization.orgData;
    },
    organizationConfiguration() {
      return this.$store.state.organization.organizationConfiguration;
    },
  },
  watch: {},
  methods: {},
  created() {},
};
</script>

<style scoped></style>
